<template>
    <div class="bill-payment" ref="screenWrapper">
        <div v-if="reviewData?.bill_count > 0" class="mb-5 text-white font-satoshi_r px-8">
            <p class="text-lg">You paid bills</p>
            <p class="text-4xl font-satoshi_b font-bold my-1">{{ $format.renderNumber(reviewData?.bill_count) }} times</p>
            <p>in total.</p>
            <p class="text-4xl font-satoshi_b font-bold my-1"><CountUpNumber :endVal="reviewData?.total_bill_amount ?? 0" currency="₦" /></p>
        </div>
        <div v-else class="mb-12 text-white font-satoshi_r px-8">
            <p class="mb-5">
                You haven’t paid bills on Sycamore! Buy eSIMs for 25+ countries 🌍, or gift cards from your favorite brands like Netflix &
                PlayStation.
            </p>
            <p>What’s more? You get 3% cashback on your bills when you create a savings plan.</p>
        </div>
        <img
            src="../../assets/images/year-in-review/bills-payment.svg"
            alt="bill-payments"
            class="block w-full sm-h:w-3/4 mx-auto"
            :class="{
                grayscale: reviewData?.bill_count <= 0,
            }"
        />
        <template v-if="reviewData?.bill_count > 0">
            <p v-if="reviewData?.total_bill_amount > 10000" class="px-8">
                Your top biller category was
                <span class="font-satoshi_b capitalize">{{ reviewData?.top_biller }}</span
                >, with a total of
                <span class="font-satoshi_b">{{ $format.renderCurrency(reviewData?.top_biller_total) }}</span>
                paid to the billers in this category.
            </p>
            <p v-else class="px-8">
                You've made a great start! Keep paying your bills with Sycamore and enjoy convenience. Let's aim to pay even more next year 💪🏽
            </p>
        </template>
    </div>
</template>

<script>
import CountUpNumber from "./CountUp.vue";

export default {
    components: {
        CountUpNumber,
    },

    props: {
        reviewData: Object,
    },

    computed: {
        status() {
            if (this.reviewData?.total_bill_amount <= 0) return "none";
            if (this.reviewData?.total_bill_amount > 0 && this.reviewData?.total_bill_amount < 50000) return "low";
            return "high";
        },
    },

    mounted() {
        const screenWrapper = this.$refs.screenWrapper;
        const hammer = new Hammer(screenWrapper);

        hammer.on("tap", () => {
            if (this.currentScreen === 0) return;
            this.$emit("goForward");
        });
    },
};
</script>

<style scoped>
.bill-payment {
    color: white;
    background-color: #f19800;
    min-height: 100vh;
    padding-top: 100px;
}

@media (max-height: 750px) {
    .bill-payment {
        padding-top: 60px !important;
    }
}
</style>
